import * as types from '../mutation-types'

const state = {
  username: null,
  roleState: localStorage.getItem('BAILIAN-PD-TEMPLATE-ROLE'),
  userType: localStorage.getItem('BAILIAN-PD-TEMPLATE-USERTYPE'),
}

const getters = {
  username: state => state.username,
  roleState: state => state.roleState,
  userType: state => state.userType,
}

const mutations = {
  [types.SETUSERNAME]: (state, value) => {
    state.username = value
  },
  [types.SETROLE]: (state, value) => {
    state.roleState = value;
  },
  [types.USERTYPE]: (state, value) => {
    state.userType = value;
  },
}

const actions = {
  setUserName ({
    commit
  }, value) {
    commit(types.SETUSERNAME, value);
  },
  setRole ({
    commit
  }, value) {
    commit(types.SETROLE, value);
  },
  setUserType ({
    commit
  }, value) {
    commit(types.USERTYPE, value);
  },
}



export default {
  state,
  getters,
  actions,
  mutations
}